import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";
import { CustomerListApi } from "./api";
import localForage from "../Common/LocalForage";

interface customerListSliceState {
  customerList: any;
  loadingState?: string;
  errorMessage?: string;
}
const initialCustomerList: any = [];
const initialState: customerListSliceState = {
  customerList: initialCustomerList,
  loadingState: undefined,
  errorMessage: undefined,
};

export const fetchCustomerList = createAsyncThunk(
  "customerList/fetchCustomerList",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      // Try to get cached data
      const cachedData:any = await localForage.getItem("customerList");
        if (cachedData) {
            // If cached data is available, dispatch it immediately
            if (typeof cachedData !== 'string') {
                dispatch(setCustomerListFromCache(cachedData));
            }
           

      }

      // Fetch data from the server
        const response = await CustomerListApi.getCustomerList();
        if (response != null) {
            if (typeof response !== 'string') {
                if (response.length > 0) {
                    // console.log(response)
                            await localForage.setItem("customerList", response); // Update cache
                 }
            }
            
        }
      if (!cachedData) {
        // Only update the state if cache was empty
          if (response != null) {
              if (typeof response !== 'string') {
                 dispatch(setCustomerListFromCache(response));
              }
          }
      }
     
    } catch (error) {
        console.log(error)
      return rejectWithValue(error.toString());
    }
  }
);

// Slice Definition
const customerListSlice = createSlice({
  name: "customerList",
  initialState,
  reducers: {
    // Reducer to set customer list from cache
    setCustomerListFromCache: (state, action) => {
      state.customerList = action.payload;
      state.loadingState = "from-cache";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerList.pending, (state) => {
        if (state.loadingState !== "from-cache") {
          state.loadingState = "pending";
          state.errorMessage = undefined;
        }
      })
      .addCase(fetchCustomerList.fulfilled, (state, action) => {
        // Only update if the state was pending to avoid overwrite from cache
        if (state.loadingState === "pending") {
          state.customerList = action.payload;
          state.loadingState = "fulfilled";
          state.errorMessage = undefined;
        }
      })
      .addCase(fetchCustomerList.rejected, (state, action) => {
        state.loadingState = "rejected";
        state.errorMessage = action.payload || "Failed to load data";
      });
  },
});

// Export actions and reducer
export const { setCustomerListFromCache } = customerListSlice.actions;

export const getCustomerListSelector = (state: RootState) =>
  state.customerList.customerList;

export const loadingCustomerListSelector = (state: RootState) =>
  state.customerList.loadingState;
export default customerListSlice.reducer;
